export default {
	name: 'MonthCondition',
	props: {
		value: {
			type: Number
		},
		timeClasses: {
			type: Array,
			default: []
		}
	},
	data () {
		return {
			val: this.value || null,
			values: [
				{ id: null, name: '指定なし' },
				...this.timeClasses
			]
		}
	},
	template: `
		<select class="m-sch__select -size-m" name="" id=""
			v-model="val"
			@change="fireInput"
			@click="$emit('controlClick')"
		>
			<option v-for="v in values" :key="v.id" :value="v.id">
				{{ v.name }}
			</option>
		</select>
	`,
	methods: {
		fireInput () {
			this.$emit('input', this.val)
		}
	},
	watch: {
		value () {
			this.val = this.value
		}
	}
}
